// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"G4-z","dimensionLabel":"H4-z","styleChooserControlWrapper":"I4-z","styleChooserControl":"J4-z","disabled":"K4-z","giftCard":"L4-z","styleChooserText":"M4-z"};